import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CmButtonDropdownComponent} from './cm-button-dropdown.component';
import {DateRangeHolder} from '../../domain/date-range-holder.model';
import {DateRangeChooserComponent} from '../date-selector/date-range-chooser.component';
import {DateRangeType} from '../../domain/date-range-type.enum';

/**
 *  this component is used within the chart widget on the dashboard. It wraps the data range chooser
 */
@Component({
  selector: 'cm-date-range-dropdown',
  template: `
    <cm-button-dropdown #dropdown [header]="'Date range'" [tooltip]="'Date range'" [icon]="'calendar-alt'">
      <cm-date-range-chooser #chooser [allowedDateRangeTypes]="allowedDateRangeTypes"
                             (dateRangeChanged)="onDateRangeChanged($event)">
      </cm-date-range-chooser>
    </cm-button-dropdown>
  `,
})
export class DateRangeDropdownComponent {
  @ViewChild(CmButtonDropdownComponent, { static: true }) dropdown: CmButtonDropdownComponent;
  @ViewChild('chooser', { static: true }) chooser: DateRangeChooserComponent;

  @Input()
  allowedDateRangeTypes: DateRangeType[];

  @Output()
  dateRangeChanged = new EventEmitter<DateRangeHolder>();

  @Input()
  set dateRange(dateRange: DateRangeHolder) {
    this.chooser.setDates(dateRange);
  }

  constructor() {
  }

  onDateRangeChanged($event) {
    this.dateRangeChanged.emit($event);
    this.dropdown.hide();
  }

  setDates(dates: DateRangeHolder) {
    this.chooser.setDates(dates);
  }
}
